import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Configuration } from '@ubie/core';

@Component({
  selector: 'acl-configurations-by-devices-list',
  standalone: false,
  templateUrl: './configurations-by-devices-list.component.html',
  styleUrl: './configurations-by-devices-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfigurationsByDevicesListComponent {
  readonly data = input<Configuration[]>([]);
}
